module.exports = __webpack_public_path__ + "static/wa_avatar-55f7a24143b5cd0e1f1a6fbf39c77920.jpg";